"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault"),
    _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _uiKit = require("@devsta/ui-kit"),
    _HelpCenterButton = _interopRequireDefault(require("../../common/components/HelpCenterButton"));

require("./styles/_error.scss");

function reloadPage() {
  window.location.reload();
}

function Error(a) {
  var b = a.onSubmitError;
  return _react["default"].createElement("div", {
    className: "error-page"
  }, _react["default"].createElement("div", {
    className: "error-page__inner"
  }, _react["default"].createElement(_uiKit.Icon, {
    className: "error-page__icon",
    name: "robot"
  }), _react["default"].createElement(_uiKit.Text, {
    className: "error-page__header",
    noMargin: "top",
    heading3: !0
  }, "Something's gone wrong. Sorry about that."), _react["default"].createElement(_uiKit.Text, {
    subtitle: !0,
    noMargin: "bottom"
  }, "Try reloading the page and try again."), _react["default"].createElement("div", {
    className: "error-page__buttons"
  }, _react["default"].createElement(_uiKit.Button, {
    onClick: reloadPage
  }, "Reload Page"), b ? _react["default"].createElement(_uiKit.Button, {
    onClick: b
  }, "Submit Error Report") : null)), _react["default"].createElement("div", {
    className: "error-page__assist"
  }, _react["default"].createElement(_uiKit.Text, {
    noMargin: "bottom"
  }, "If you keep running into this problem, try contacting your Account Manager or visit our", _react["default"].createElement("strong", null, _react["default"].createElement(_HelpCenterButton["default"], null)), "for more information.")));
}

var _default = (0, _react.memo)(Error);

exports["default"] = _default;